import React, { Component } from "react";
import "../../styles/login.css";
import axios from "axios";
import { Link } from "react-router-dom";
import { validateAll } from "indicative";
import { recalculateBasket } from '../../shared/constants';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      emailOrPhoneNumber: "",
      password: "",
      showPassword: false,
      errors: {
        emailOrPhoneNumber: "",
        password: ""
      },
      responseError: "",
      disabled: false
    };
  }

  toggleShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ disabled: true });
    const data = this.state;

    const messages = {
      required: "Це поле є обов'язковим",
      "emailOrPhoneNumber.max": "Довжина поля повинна бути не більшою 100 символів",
      "emailOrPhoneNumber.min": "Довжина поля повинна бути не менше 5 символів"
    };

    const rules = {
      emailOrPhoneNumber: "required | string | min:5 | max:100",
      password: "required | string"
    };

    validateAll(data, rules, messages)
      .then(() => {
        const realThis = this;

        const request = {
          emailOrPhoneNumber: data.emailOrPhoneNumber,
          password: data.password
        }

        axios
          .post("/api/v1/auth/login", request)
          .then(function(res) {
            localStorage.setItem("token", res.data.data.token);
            recalculateBasket(res.data.data.token);
            const currentUrl = localStorage.getItem("currentUrl");
            const authPaths = ["/login", "/signup", "/restore-password"];
            const isValidReturnUrl = currentUrl && !authPaths.some(p => currentUrl.startsWith(p));
            realThis.props.history.push(isValidReturnUrl ? currentUrl : "/user/personal-cabinet");
          })
          .catch(function(error) {
            const res = error.response;
            if (res.data.isError) {
              realThis.setState({
                responseError: res.data.errorMessage,
                errors: {},
                disabled: false
              });
            }
          });
      })
      .catch(errors => {
        this.setState({ responseError: null });
        const formattedErrors = {};
        errors.forEach(error => (formattedErrors[error.field] = error.message));
        this.setState({ errors: formattedErrors, disabled: false });
      });
  };

  render() {
    const { emailOrPhoneNumber, password, showPassword, responseError, errors, disabled } = this.state;
    return (
      <div id="loginBody">
        <div className="login-form">
          <form action="" onSubmit={this.handleSubmit} method="post">
            <h2 className="login-form-title">Вхід до кабінету</h2>
            <div className="form-group">
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="fa fa-user"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  name="emailOrPhoneNumber"
                  placeholder="Номер телефону або імейл"
                  onChange={this.onChange}
                  value={emailOrPhoneNumber}
                />
              </div>
              <div className="form-field-error">{errors.emailOrPhoneNumber}</div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="fa fa-lock"></i>
                </span>
                <div className="login-password-input-wrap">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control login-password-input"
                    name="password"
                    placeholder="Пароль"
                    onChange={this.onChange}
                    value={password}
                  />
                  <span
                    className="login-password-toggle"
                    onClick={this.toggleShowPassword}
                    onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); this.toggleShowPassword(); } }}
                    role="button"
                    tabIndex={0}
                    title={showPassword ? "Приховати пароль" : "Показати пароль"}
                    aria-label={showPassword ? "Приховати пароль" : "Показати пароль"}
                  >
                    <i className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                  </span>
                </div>
              </div>
              <div className="form-field-error">{errors.password}</div>
            </div>
            <input
              type="submit"
              className="btn btn-dark btn-block btn-lg login-submit-btn"
              value="Увійти в профіль"
              disabled={disabled}
            />
            <div className="form-field-error-special pt-2">{responseError}</div>
          </form>
          <div className="text-center pt-3">
            Забули пароль? <Link to="/restore-password" className="login-link-accent">Відновити</Link>
          </div>
          <div className="text-center">
            Ще не створили аккаунт? <Link to="/signup" className="login-link-accent">Зареєструйтесь</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
